import React, { useState } from "react";
import TopNavbar from "../top-navbar/TopNav";
import Sidebar from "./Sidebar";
import {
  verifyQuickCriminal,
  saveQuickCriminal,
} from "../../services/employee/api";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../loader/Loader";
import "react-toastify/dist/ReactToastify.css";

const indianStates = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", 
  "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", 
  "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", 
  "Odisha", "Orissa", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", 
  "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", 
  "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", 
  "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
];

const QuickCriminalCheck = () => {
  const [loading, setLoading] = useState(false);
  const [savedRecords, setSavedRecords] = useState({});
  const [recordsToSave, setRecordsToSave] = useState([]);
  const [overallSaving, setOverallSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    father_name: "",
    address: "",
    year: "",
    state: "",
  });

  const [criminalData, setCriminalData] = useState(null);
  const id = localStorage.getItem("QuickBGC_candidateID");
  const navigate = useNavigate();

  const handleBack = () => {
    if (id) {
      navigate(`/employee/quickbgv-dashboard/${id}`);
    } else {
      navigate(-1);
    }
  };

  const nameRegex = /^[A-Za-z\s]+$/;
  const yearRegex = /^\d{4}$/;

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Candidate Name is required";
    } else if (!nameRegex.test(formData.name)) {
      newErrors.name = "Only alphabets allowed";
    }

    if (!formData.father_name.trim()) {
      newErrors.father_name = "Father Name is required";
    } else if (!nameRegex.test(formData.father_name)) {
      newErrors.father_name = "Only alphabets allowed";
    }

    if (!formData.year.trim()) {
      newErrors.year = "Year is required";
    } else if (!yearRegex.test(formData.year)) {
      newErrors.year = "Enter a valid 4-digit year";
    }

    if (!formData.address.trim()) {
      newErrors.address = "Address is required";
    }

    if (!formData.state) {
      newErrors.state = "State is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if ((name === "name" || name === "father_name") && !/^[A-Za-z\s]*$/.test(value)) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleVerify = async (e) => {
    if (e) e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fix highlighted validation errors.");
      return;
    }

    try {
      setLoading(true);
      const response = await verifyQuickCriminal({ ...formData });

      if (response?.data?.status || response?.data?.success) {
        const results = response?.data?.data?.data || response?.data?.result || null;
        setCriminalData(results);
        setSavedRecords({});
        setRecordsToSave([]);
        if (results?.result?.length === 0) {
          toast.info("No criminal records found.");
        }
      } else {
        toast.error("Failed to retrieve criminal records.");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to fetch criminal records."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSaveRecord = (record, index) => {
    const formattedRecord = {
      year: record.year || formData.year || "",
      state: record.state || formData.state || "",
      petitioner: record.petitioner || "",
      respondent: record.respondent || "",
      respondent_address: record.respondent_address || "",
      filingNumber: record.filing_number || "",
      caseName: record.case_name || "",
      caseStatus: record.case_status || "",
      caseNumber: record.case_no || "",
      caseType: record.case_type || "",
      firlink: record.fir_link || "",
      court_name: record.court_name || "",
      district: record.district || "",
    };

    setRecordsToSave((prev) => [...prev, formattedRecord]);

    setSavedRecords((prev) => ({
      ...prev,
      [index]: true,
    }));
    toast.success("Record added saved Successful.");
  };

  const handleFinalDecision = async (status) => {
    try {
      setOverallSaving(true);

      const candidateId = localStorage.getItem("QuickBGC_candidateID");

      if (!candidateId) {
        toast.error("Candidate ID is missing.");
        return;
      }

      const criminalCheckStatus = status === "pass" ? "SUCCESS" : "FAIL";

      const payload = {
        client_id: criminalData?.client_id || "",
        candidateId: candidateId,
        name: formData.name,
        father_name: formData.father_name,
        address: formData.address,
        year: formData.year,
        checkStatus: "COMPLETED",
        criminalCheckStatus: criminalCheckStatus,
        state: formData.state,
        result: recordsToSave,
      };

      const response = await saveQuickCriminal(payload);
      if (response?.data?.status || response?.data?.success) {
        toast.success(
          `Criminal check updated successfully as ${criminalCheckStatus}.`
        );
        handleBack();
      } else {
        toast.error(
          response?.data?.message || "Failed to save criminal check details."
        );
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to save record."
      );
    } finally {
      setOverallSaving(false);
    }
  };

  const hasSavedRecords = Object.keys(savedRecords).length > 0;

  return (
    <div className="dashboard-app-container">
      {(loading || overallSaving) && <Loader />}
      <Sidebar />

      <div className="dashboard-right-panel">
        <TopNavbar />

        <div className="container-fluid py-4">
          <div className="quickbgv-criminal-card">
            <div className="quickbgv-criminal-header bg-white rounded-top">
              <div className="d-flex align-items-center gap-3">
                <button
                  type="button"
                  className="quick-btn-back-custom p-0 d-flex align-items-center justify-content-center"
                  onClick={handleBack}
                  title="Go Back"
                >
                  <FaArrowLeft size={16} />
                </button>

                <div className="flex-grow-1">
                  <h3
                    className="fw-bold mb-1"
                    style={{ color: "#4a154b", fontSize: "1.25rem" }}
                  >
                    Criminal Background Verification
                  </h3>
                  <p className="text-muted mb-0" style={{ fontSize: "0.875rem" }}>
                    Verify candidate criminal records using provided personal
                    information.
                  </p>
                </div>
              </div>
            </div>

            {!criminalData ? (
              <form onSubmit={handleVerify}>
                <div className="row g-4 mt-1">
                  <div className="col-lg-6">
                    <label className="form-label">
                      Candidate Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Enter Candidate Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </div>

                  <div className="col-lg-6">
                    <label className="form-label">
                      Father Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="father_name"
                      className="form-control"
                      placeholder="Enter Father Name"
                      value={formData.father_name}
                      onChange={handleChange}
                    />
                    {errors.father_name && (
                      <small className="text-danger">{errors.father_name}</small>
                    )}
                  </div>

                  <div className="col-lg-6">
                    <label className="form-label">
                      Year <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="year"
                      className="form-control"
                      placeholder="Enter Year (e.g., 2021)"
                      value={formData.year}
                      onChange={handleChange}
                    />
                    {errors.year && (
                      <small className="text-danger">{errors.year}</small>
                    )}
                  </div>

                  <div className="col-lg-6">
                    <label className="form-label">
                      State <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                    >
                      <option value="">Select State</option>
                      {indianStates.map((st, i) => (
                        <option key={i} value={st}>
                          {st}
                        </option>
                      ))}
                    </select>
                    {errors.state && (
                      <small className="text-danger">{errors.state}</small>
                    )}
                  </div>

                  <div className="col-12">
                    <label className="form-label">
                      Address <span className="text-danger">*</span>
                    </label>
                    <textarea
                      rows="4"
                      className="form-control"
                      name="address"
                      placeholder="Enter Full Address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                    {errors.address && (
                      <small className="text-danger">{errors.address}</small>
                    )}
                  </div>
                </div>

                <div className="quickbgv-criminal-actions mt-4">
                  <button
                    type="submit"
                    className="quickbgv-criminal-btn"
                    disabled={loading}
                  >
                    {loading ? "Verifying..." : "Search Criminal Records"}
                  </button>
                </div>
              </form>
            ) : (
              <>
                <div className="quickbgv-result-card">
                  <div className="quickbgv-result-header">
                    <div>
                      <h4 className="mb-1">E-Court Verification Result</h4>
                      <p className="text-muted mb-0">
                        Criminal background records fetched successfully
                      </p>
                    </div>

                    <span className="quickbgv-status-pill success">
                      Records Found : {criminalData.result?.length || 0}
                    </span>
                  </div>

                  <div className="quickbgv-table-wrapper">
                    <div className="table-responsive">
                      <div className="assigne-candidate-table-container">
                        <table className="assigne-candidate-table">
                          <thead>
                            <tr>
                              <th>Year</th>
                              <th>Case Type</th>
                              <th>Petitioner</th>
                              <th>Respondent</th>
                              <th>Court</th>
                              <th>District</th>
                              <th>State</th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {criminalData?.result?.length > 0 ? (
                              criminalData.result.map((record, index) => {
                                const isSaved = Boolean(savedRecords[index]);

                                return (
                                  <tr key={index}>
                                    <td>{record.year || "-"}</td>
                                    <td>{record.case_type || "-"}</td>
                                    <td>{record.petitioner || "-"}</td>
                                    <td>{record.respondent || "-"}</td>
                                    <td>{record.court_name || "-"}</td>
                                    <td>{record.district || "-"}</td>
                                    <td>{record.state || "-"}</td>
                                    <td>
                                      <button
                                        className="quick-criminal-save-btn"
                                        disabled={isSaved}
                                        onClick={() => handleSaveRecord(record, index)}
                                        type="button"
                                      >
                                        {isSaved ? "Saved" : "Save"}
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center py-4">
                                  No Criminal Records Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center gap-3 mt-4">
                    <button
                      className="quick-criminal-Pass-btn"
                      disabled={hasSavedRecords || overallSaving}
                      onClick={() => handleFinalDecision("pass")}
                      type="button"
                    >
                      Pass
                    </button>

                    <button
                      className="quick-criminal-Fail-btn"
                      disabled={overallSaving}
                      onClick={() => handleFinalDecision("fail")}
                      type="button"
                    >
                      Fail
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default QuickCriminalCheck;